import Linkify from 'linkify-react';
import { merge } from 'lodash';

const defaultProperties = {
  target: '_blank',
};

const LinkifyWrapper = ({ children, properties = defaultProperties }) => (
  <span className="Linkify">
    <Linkify options={merge(defaultProperties, properties)}>
      {children}
    </Linkify>
  </span>
);

export default LinkifyWrapper;
